import React from 'react';
import { Bar } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const CostiRankingTableSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Bar
                        title={t("Costs by Area")}
                        dataProviderName={'statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_area_name/value'}
                        filters={filterModel}
                        direction={'horizontal'}
                        format={'currency'}
                    />
                </Box>

                <Box className="report-item">
                    <Bar
                        title={t("Costs by Source Type")}
                        dataProviderName={'statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_source_type/value'}
                        filters={filterModel}
                        direction={'horizontal'}
                        format={'currency'}
                    />
                </Box>

                <Box className="report-item">
                    <Bar
                        title={t("Costs by Source")}
                        dataProviderName={'statisticsviews/costsperarea/aggregatedsumfinancial/views_advertisings_advertisingcost/_related_source_name/value'}
                        filters={filterModel}
                        direction={'horizontal'}
                        format={'currency'}
                    />
                </Box>
                
            </Box>
            
        </Box>
    )
}

export default CostiRankingTableSet;
